import { Grid, StyledCard } from "@rentiohq/web-shared/dist/components";
import styled from "@rentiohq/web-theme";

export const Wrapper = styled((props: any) => <Grid {...props} />)`
  ${StyledCard} {
    height: 100%;
  }
`;
